export default "__VITE_ASSET__pGdGcSWT__"